import { Component } from '@angular/core';

@Component({
  selector: 'lib-survey-login',
  imports: [],
  templateUrl: './survey-login.html',
  styleUrl: './survey-login.css',
})
export class SurveyLogin {

}
